module.exports = __webpack_public_path__ + "img/microsoft-logo-png-transparent-20.0fa3e385.png";